module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-titlec",
    attrs: {
      "id": "lev_17"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("Civilian and Naval Leaders of the Spanish Bourbon Navy")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section1"
  }, [_vm._v("HEADS OF STATE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The monarchs of the Habsburg era from 1504 to 1700 are detailed in the Chronology section of this book. The subsequent rulers of Spain under the Bourbon dynasty (including the Napoleonic Usurpation) are set out below.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hangt"
  }, [_vm._v("Felipe V (1.11.1700–15.1.1724 abdication)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Luis I (15.1.1724–6.9.1724 died)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Felipe V (reinstated 6.9.1725–9.7.1746)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Fernando VI (9.7.1746–10.8.1759)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Carlos III (10.8.1759–14.12.1788)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Carlos IV (14.12.1788–19.3.1808 abdication)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Fernando VII (19.3.1808–5.5.1808 enforced ‘abdication’)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Carlos IV (reinstated 5–6.5.1808 second abdication)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Napoleon I (in theory, 6.5.1808–6.6.1808)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José (Joseph Bonaparte) (6.6.1808–11.12.1813)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Fernando VII (reinstated 11.12.1813–29.9.1833)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Isabel II (29.9.1833–30.9.1868 deposition)")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0035-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A naval officer as well as a politician, Luis María de Salazar y Salazar (born in 1758) took part in the attack on Algiers in 1775, and in a number of later naval actions before being sent to Madrid in 1792, where he participated in the drafting of Navy Ordinances. He held a number of political and administrative positions during the War with France, and, holding absolutist views, became Ministro de Marina in 1814–1816, in 1820, and in 1823–1832. He died in 1838. (MNM 5168)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Note that Felipe V inherited an empire covering a number of disparate realms and kingdoms, each with their own long-standing rights and privileges, and found several of them to be supporting his rival claimant to the throne, Karl of Austria. Angered by this, and seeking to emulate his own native France as a model of a centralised state, Felipe enacted a system of ordinances – known as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nueva Planta")]), _vm._v(" decrees – to curb the rights and privileges of the various territories. At first promulgated in Valencia and Aragon in 1707, Felipe waited until the end of the War of the Spanish Succession before extending the laws to other territories, ending with Catalonia on 16 January 1716.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section1"
  }, [_vm._v("HEADS OF GOVERNMENT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The title of the leading Minister within the Government of Spain was initially described as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secretario del Despacho Universal")]), _vm._v(" (‘Secretary of the Universal Bureau’), but in November 1734 it was altered to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Primer Secretario de Estado")]), _vm._v(" (First Secretary of State), a title thus held by José de Patiño who can be described as Spain’s first Prime Minister. In January 1834 the title changed to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Presidente del Consejo de Ministros")]), _vm._v(" (President of the Council of Ministers).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hangt"
  }, [_vm._v("Pedro Fernández del Campo y Salvatierra, Marqués de Mejorada (11.7.1708–15.4.1714)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Manuel de Vadillo y Velasco (15.4.1714–30.11.1714)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José de Grimaldo y Gutiérrez de Solórzano, Marqués de Grimaldo (30.11.1714–14.1.1724)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Juan Bautista de Orendain y Azpilicueta (14.1.1724–4.9.1724)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José de Grimaldo (second term) (4.9.1724–12.12.1725)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Juan Guillermo Ripperdá (Duque y Barón de Ripperdá) (12.12.1725– 14.4.1726)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José de Grimaldo (third term) (14.4.1726–1.10.1728)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Juan Bautista de Orendain, Marqués de La Paz (second term) (1.10.1728–21.11.1734)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José de Patiño y Rosales (21.11.1734–3.11.1736)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Sebastián de la Cuadra y Llerena, Marqués de Villarías (26.11.1736– 4.12.1746)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José de Carvajal y Lancaster (4.12.1746–9.4.1754)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Fernando de Silva Mendoza y Toledo, Duque de Huéscar (9.4.1754– 15.5.1754)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Ricardo Wall y Devreux (15.5.1754–9.10.1763)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Pablo Jerónimo de Grimaldi y Paliavicini, Duque de Grimaldi (9.10.1763–19.2.1777)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José Moñino y Redondo, Conde de Floridablanca (19.2.1777–28.2.1792)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Pedro Pablo Abarca de Bolea y Ximénez de Urrea, Conde de Aranda (28.2.1792–15.11.1792)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Manuel de Godoy y Álvarez de Faria, Duque de Alcudia (15.11.1792– 28.3.1798)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Francisco Saavedra de Sangronis (30.3.1798–21.2.1799)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Mariano Luis de Urquijo y Muga (12.2.1799–13.12.1799)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("Pedro Cevallos Guerra (13.12.1799–3.3.1808)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Gonzalo O’Farrill y Herrera (3.3.1808–19.3.1808)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Pedro Cevallos Guerra (second term) (19.3.1808–7.7.1808)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Mariano Luis de Urquijo (second term) (7.7.1808–27.6.1813)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Juan O’Donoju O’Ryan (10.10.1813–17.10.1813)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Fernando de Laserna (17.10.1813–3.12.1813)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José Luyando (3.12.1813–4.5.1814)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José Miguel de Carvajal-Vargas y Manrique de Lara, Duque de San Carlos (4.5.1814–15.11.1814)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Pedro Cevallos Guerra (third term) (15.11.1814–24.1.1816)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Juan Estaban Lozano de Torres (24.1.1816–26.1.1816)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Pedro Cevallos Guerra (fourth term) (26.1.1816–30.10.1816)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José García de León y Pizarro (30.10.1816–14.9.1818)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Carlos Martínez de Irujo y Tacón, Marqués de Casa Irujo (14.9.1818– 12.6.1819)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Manuel González Salmón y Gómez de Torres (12.6.1819–12.9.1819)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Joaquín Jose Melgarejo y Saurin, Duque de San Fernando de Quiroga (12.9.1819–18.3.1820)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Juan Jabat Aztal (a few hours only!) (18.3.1820)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Evaristo Pérez de Castro y Brito (18.3.1820–2.3.1821)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Joaquín Anduaga Cuenca (2.3.1821–23.4.1821)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Francisco de Paula Escudero (a few hours only!) (23.4.1821)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Eusebio Bardaji y Azara (23.4.1821–8.1.1822)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Ramón López Pelegrin (8.1.1822–24.1.1822)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José Gabriel de Silva y Bazán (24.1.1822–30.1.1822)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Ramón López Pelegrin (second term) (30.1.1822–28.2.1822)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Francisco Martínez de la Rosa (28.2.1822–5.8.1822)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Evaristo Fernández San Miguel y Valledor (5.8.1822–25.4.1823)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José Manuel Vadillo (25.4.1823–7.5.1823)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Santiago Usoz y Mozi (7.5.1823–13.5.1823)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José María Pando de la Riva y Ramírez de Laredo (13.5.1823– 29.8.1823)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Luis María de Salazar y Salazar (29.8.1823–4.9.1823)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Juan Antonio Yandiola Garay (4.9.1823–6.9.1823)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José Luyando (second term) (6.9.1823–1.10.1823)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Victor Damián Sáez y Sánchez-Mayor (25.4.1823–2.12.1823)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Carlos Martínez de Irujo y Tacón (second term) (2.12.1823–18.1.1824)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Narciso Fernández de Heredia y Begines de los Rios, Conde de Ofalia 18.1.1824–11.7.1824)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Luis María de Salazar (second term, for a few hours only) (11.7.1824)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Francisco Cea Bermúdez (11.7.1824–24.10.1825)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Pedro Alcántara Álvarez de Toledo y Salm Salm, Duque del Infantado (24.10.1825–19.8.1826)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Manuel González Salmón (second term) (19.8.1826–20.1.1832)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Francisco Tadeo Calomarde y Arria (20.1.1832–22.2.1832)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Antonio de Saavedra y Frigola, Conde de Alcudia (22.2.1832– 1.10.1832)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José Cafranga Costilla (1.10.1832–29.11.1832)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Francisco Cea Bermúdez (second term) (29.11.1832–15.1.1834)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Francisco Martínez de la Rosa (second term) (15.1.1834–7.6.1835)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José María Queipo de Llano, Conde de Toreno (7.6.1835–14.9.1835)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Miguel Ricardo de Álava (14.9.1835–25.9.1835)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Juan Álvarez Mendizábal (25.9.1835–15.5.1836)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Francisco Javier de Istúriz (15.5.1835–14.8.1836)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José María Calatrava (14.8.1836–18.8.1837 with brief interval 10.3.1837–3.4.1837)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Baldomero Espartero, Conde de Luchana (18.8.1837–18.10.1837)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Eusebio Bardají Azara (18.10.1837–18.12.1837)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Narciso Heredia, Conde de Ofalia (16.12.1837–6.9.1838)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Bernardino Fernández de Velasco, Duque de Frías (6.9.1838–9.12.1838)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Evaristo Pérez de Castro (9.12.1838–20.7.1840)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Antonio González (20.7.1840–12.8.1840)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Valentín Ferraz (12.8.1840–28.8.1840)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Modesto Cortázar (29.8.1840–11.9.1840)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Vicente Sancho (11.9.1840–16.9.1840)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Baldomero Espartero, Duque de la Victoria y Morella (second term) (16.9.1840–10.5.1841)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Joaquín María Ferrer (10.5.1841–20.5.1841)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Antonio González (second term) (20.5.1841–17.6.1842)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José Ramón Rodil, Marqués de Rodil (17.6.1842–9.5.1843)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Joaquín María López (9.5.1843–19.5.1843)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Álvaro Gómez Becerra (19.5.1843–23.7.1843)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Joaquín María López (second term) (23.7.1843–20.11.1843)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Salustiano Olózaga (20.11.1843–29.11.1843)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Luis González Bravo (5.12.1843–3.5.1844)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Ramón María Narváez (3.5.1844–11.2.1846)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Manuel Pando, Marques de Miraflores (12.2.1846–16.3.1846)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Ramón María Narváez, Duque de Valencia (second term) (16.3.1846– 5.4.1846)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Francisco Javier de Istúriz (second term) (5.4.1846–28.1.1847)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Carlos Martínez de Irujo, Duque de Sotomayor (28.1.1847–28.3.1847)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Joaquín Francisco Pacheco (28.3.1847–31.8.1847)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Florencio García Goyana (12.9.1847–4.10.1847)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Ramón María Narváez, Duque de Valencia (third term) (4.10.1847– 19.10.1849)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Serafín María de Sotto, Conde de Clonard (19.10.1849–20.10.1849)")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0036-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Secretario del Despacho de Marina e Indias in 1743–1754, Zenón de Somodevilla y Bengoechea, the Marqués de la Ensenada from December 1736, was Minister of Finance, War, the Navy and the Indies; he oversaw the massive expansion of the Spanish Navy in the early 1750s, following its losses in the previous decade. As Captain-General of both the Navy and the Army, he persuaded the King to adopt British concepts of design and construction, appointing Jorge Juan to reorganise the dockyards as well as assume overall control of all construction. (MNM 0417)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("Ramón María Narváez, Duque de Valencia (fourth term) (20.10.1849– 10.1.1851)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José Bravo Murillo (14.1.1851–14.12.1852)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Federico Roncali, Conde de Alcoy (14.12.1852–14.4.1853)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Francisco Lersundi (14.4.1853–19.9.1853)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Luis José Sartorius, Conde de San Luis (19.9.1853–17.7.1854)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Fernando Fernández de Córdova (17.7.1854–19.7.1854)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Ángel de Saavedra, Duque de Rivas (18.7.1854–19.7.1854)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Baldomero Espartero, Duque de la Victoria y Morella (third term) (19.7.1854–14.7.1856)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Leopoldo O’Donnell, Conde de Lucena (14.7.1856–12.10.1856)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Ramón María Narváez, Duque de Valencia (fifth term) (12.10.1856– 15.10.1857)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Francisco Armero Peñaranda (15.10.1857–14.1.1858)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Francisco Javier de Istúriz (third term) (14.1.1858–30.6.1858)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Leopoldo O’Donnell, Conde de Lucena (second term) (30.6.1858– 7.11.1859)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Saturnino Calderón Collantes (7.11.1859–30.4.1860)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Leopoldo O’Donnell, Duque de Tetuán (third term) (30.4.1860– 2.3.1863)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Manuel Pando, Marqués de Miraflores (second term) (2.3.1863– 17.1.1864)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Lorenzo Arrazoia (17.1.1864–1.3.1864)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Alejandro Mon (1.3.1864–16.9.1864)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Ramón María Narváez, Duque de Valencia (sixth term) (16.9.1864– 21.6.1865)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Leopoldo O’Donnell, Duque de Tetuan (fourth term) (21.6.1865– 10.7.1866)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Ramón María Narváez, Duque de Valencia (seventh term) (10.7.1866– 22.4.1868)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("Luis González Bravo (23.4.1868–19.9.1868)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-hang"
  }, [_vm._v("José Gutiérrez de la Concha, Marqués de la Habana (19.9.1868– 30.9.1868)")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0037-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Antonio Valdés y Fernández de Bazán (born in 1744) served in the defence of the Morro Castle during the siege of Havana in 1762, and was then in the Mediterranean until 1767. He was appointed Ministro de Marina in March 1783 following the death of González de Castejón. He held this post until November 1795, being also promoted to Captain-General in 1792; he died in December 1795. (MNM 0416)")])]), _vm._v(" "), _c('h4', {
    staticClass: "sub-section1"
  }, [_vm._v("SECRETARIES OF THE NAVY/MINISTER OF MARINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spain was fortunate during the 18"), _c('sup', [_vm._v("th")]), _vm._v(" century to be administered for the Crown by a remarkable series of Naval Ministers – the actual title varied from an initial "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secretario del Despacho de Marina y Indias")]), _vm._v(" to (from 20 September 1751) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ministro de Marina")]), _vm._v(" – who not only oversaw the growth and development of the Navy and its infrastructure ashore as well as afloat from the official establishment of the Real Marina in 1714, but also provided the Navy with a good organisation as well as ensuring major bases were built.")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "indent-numhy"
  }, [_c('span', {
    staticClass: "numhy"
  }, [_vm._v("1.-")]), _vm._v(" Bernardo Tinajero de la Escalera 30.11.1714–1715 Following Tinajero, the post was absorbed on 28.4.1715 into that of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secretario de Guerra")]), _vm._v(" (which was renamed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Guerra y Marina")]), _vm._v("), but was reestablished as independent on 1.4.1721.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy"
  }, [_c('span', {
    staticClass: "numhy"
  }, [_vm._v("2.-")]), _vm._v(" Andrés de Pez, 1721–1723 (died 7.5.1723)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy"
  }, [_c('span', {
    staticClass: "numhy"
  }, [_vm._v("3.-")]), _vm._v(" Antonio Sopeña, 1723–1726")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy"
  }, [_c('span', {
    staticClass: "numhy"
  }, [_vm._v("4.-")]), _vm._v(" José Patiño y Rosales, 1726–1736 (died 3.11.1736)")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0037-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("One of Spain’s most outstanding naval officers, José de Mazarredo y Salazar (born 1745) led the defence of Cádiz against the blockade of that port by Jervis and Nelson in 1797. Appointed as Ministro de Marina in 1808, he served in that role until his death in 1812. (MNM 0351)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('span', {
    staticClass: "numhy"
  }, [_vm._v("5.-")]), _vm._v(" Mateo Pablo Díaz de Lavandero Martín, Marqués de Torrenueva, 1736–1739")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy"
  }, [_c('span', {
    staticClass: "numhy"
  }, [_vm._v("6.-")]), _vm._v(" José de la Quintana, 1739–1741")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy"
  }, [_c('span', {
    staticClass: "numhy"
  }, [_vm._v("7.-")]), _vm._v(" José del Campillo y Cossío, 1741–1743 (died 11.4.1743)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy"
  }, [_c('span', {
    staticClass: "numhy"
  }, [_vm._v("8.-")]), _vm._v(" Zenón de Somodevilla y Bengoechea, Marqués de la Ensenada, 1743–1754 (died 2.12.1781)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy"
  }, [_c('span', {
    staticClass: "numhy"
  }, [_vm._v("9.-")]), _vm._v(" Julián Manuel de Arriaga y Ribera, Duque de Estrada, 1754–1776 (died 28.1.1776)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("10.-")]), _vm._v(" Pedro González de Castejón y Salazar, 1776–1783, (died 19.3.1783)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("11.-")]), _vm._v(" Antonio Valdés y Fernández de Bazán, 3.1783–13.11.1795")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("12.-")]), _vm._v(" Pedro Varela de Ulloa, 1795–1796")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("13.-")]), _vm._v(" Juan de Lángara y Huarte, 1796–1799")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("14.-")]), _vm._v(" Antonio Cornell, 1799–1801")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("15.-")]), _vm._v(" José Antonio Caballero (interim) 1801–1802")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("16.-")]), _vm._v(" Domingo Pérez de Grandallana, 1802–1805")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("17.-")]), _vm._v(" Francisco Gil de Taboada y de Lemus y Villamarín (22.4.1806– 2.6.1808)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("18.-")]), _vm._v(" José de Mazarredo y Salazar (2.6.1808–29.7.1812)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("19.-")]), _vm._v(" Antonio de Escaño (15.10.1808–10.1.1810)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("20.-")]), _vm._v(" Gabriel Císcar Císcar (31.1.1810–1.11.1810)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("21.-")]), _vm._v(" José Vázquez Figueroa (23.6.1812–18.4.1813)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("22.-")]), _vm._v(" Francisco de Paula Ossorio y Vargas (18.4.1813–29.5.1814)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("23.-")]), _vm._v(" Luis María de Salazar y Salazar (29.5.1814–27.1.1816)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("24.-")]), _vm._v(" José Vázquez Figueroa (27.1.1816–14.9.1818)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("25.-")]), _vm._v(" Baltasar Hidalgo de Cisneros (14.9.1818–13.6.1819)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("26.-")]), _vm._v(" José María de Alós y de Mora (13.6.1819–9.3.1820)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("27.-")]), _vm._v(" Luis María de Salazar y Salazar (9.3.1820–6.4.1820)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("28.-")]), _vm._v(" Juan Jabat Aztal (6.4.1820–2.3.1821)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("29.-")]), _vm._v(" Diego Méndez de la Vega Infanzón (2.3.1821–4.3.1821)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("30.-")]), _vm._v(" Francisco de Paula Escudero (4/3.1821–18.1.1822)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("31.-")]), _vm._v(" Francisco de Paula Ossorio y Vargas (18.1.1822–28.2.1822)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("32.-")]), _vm._v(" Jacinto de Romarate Salamanca (28.2.1822–5.8.1822)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("33.-")]), _vm._v(" Dionisio Capaz Rendón (5.8.1822–28.2.1823)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("34.-")]), _vm._v(" Ramón Lorenzo Romay Jiménez de Cisneros (28.2.1823– 20.4.1823)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("35.-")]), _vm._v(" Antonio Campuzano (15.5.1823–18.5.1823)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("36.-")]), _vm._v(" Francisco de Paula Ossorio y Vargas (18.5.1823–30.9.1823)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("37.-")]), _vm._v(" Luis María de Salazar y Salazar (27.5.1823–15.10.1832)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("38.-")]), _vm._v(" Francisco Javier Ulloa de Ulloa y Ramírez de Laredo (15.10.1832– 25.3.1833)")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0038-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jacinto de Romarate Salamanca took part in the campaign against France in the Mediterranean, and in the occupation and defence of Toulon in 1793. In Montevideo in 1804 he participated in the reconquest of Buenos Aires, and in its subsequent defence against the British forces of Lt-General John Whitelocke; he continued to serve in the naval actions against the insurgents in Rio de la Plata until his return to Spain in 1815. He was appointed Ministro de Marina in 1820, but his liberal views meant that he was removed from that post. Following Fernando VII’s death in 1835 he was appointed JdE as a member of the Governing Board of the Navy, but died in the same year. (MNM 4784)")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0038-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Born in November 1687 at Messina at a time when Spain controlled most of Italy, Juan José Navarro joined the Spanish Navy in 1717 and was appointed by José de Patiño to the Naval Academy in Cádiz. He became an advocate for naval reform and tactics, and contributed much to the academic side of naval concepts. His command of the Spanish forces at the Battle of Toulon in February 1744 saw him created Marqués de la Victoria and promoted to Teniente General. In March 1750 he was raised to the newly-revived rank of Captain-General, a post he held until 1772. He died in 1772 at Cádiz from gangrene. (MNM 4172)")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "page_39"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0039-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Born at Seville in December 1706, Luis de Córdova y Córdova rose through the ranks of the Spanish Navy, becoming a Captain in 1740, a Jefe de Escuadra in 1760 and Teniente General in December 1774. He became Director General of the Navy in February 1780 and in 1782 commanded the naval forces blockading Gibraltar. On 20 October of that year he led the Spanish forces at the inconclusive Battle of Cape Spartel. He became Capitán General of the Navy in 1782 but retired shortly after and died at San Fernando, Cádiz in July 1796. (MNM 0434)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("39.-")]), _vm._v(" José de la Cruz (25.3.1833–16.11.1833)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("40.-")]), _vm._v(" Antonio Ramón Zarco del Valle y Huet (16.11.1833–15.1.1834)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("41.-")]), _vm._v(" José Vázquez Figueroa (15.1.1834–13.6.1835)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("42.-")]), _vm._v(" Miguel Ricardo Álava Esquivel (13.6.1835–28.8.1835)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("43.-")]), _vm._v(" José Sartorio (28.8.1835–14.9.1835)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("44.-")]), _vm._v(" Juan Álvarez Mendizábal (14.9.1835–2.5.1836)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("45.-")]), _vm._v(" José María Chacón y Pery (2.5.1836–15.5.1836)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("46.-")]), _vm._v(" Antonio Alcalá Galiano (15.5.1836–14.8.1836)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("47.-")]), _vm._v(" Miguel Moreno (14.8.1836–18.8.1836)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-numhy1"
  }, [_c('span', {
    staticClass: "numhy1"
  }, [_vm._v("48.-")]), _vm._v(" Andrés García Camba (18.8.1836–11.9.1836)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 11 September 1836 the Ministry was renamed Ministro de Marina, Comercio y Ultramar (‘Ministry of the Navy, Commerce and Overseas Governance’); the word ‘Commerce’ was removed in 1847, and the title reverted to ‘Ministry of the Navy’ later that year, but continued to be a short-term position for the holders of that office, with the title changing hands 69 times between September 1836 and September 1868.")]), _vm._v(" "), _c('h5', {
    staticClass: "sub-section2"
  }, [_vm._v("CAPITAN-GENERAL OF THE ARMADA")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The highest naval rank, although it had existed under the Habsburgs (each of the squadron commanders of the 1588 Armada had the title of Capitán General), was not re-established under the Bourbons until it was created by Carlos III by Royal Order of 15 March 1750 (until then the highest naval rank was Teniente General). Between then and 1869 (when it was replaced by ‘Admiral’), thirty-six men held the rank, although this list is limited to those 25 who were in post before 1860. Note that initially, like the rank of Admiral of the Fleet in the British Navy, only one person could be appointed to the rank, and that person generally held the rank until their death.")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("1. 15.3.1750")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Juan José Navarro de Viana y Búfalo, Marqués de la Victoria (died 5.2.1772)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("2. 15.2.1783")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Luis de Córdova y Córdova (died 29.9.1796)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("3. 1789")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Pedro Fitz-James Stuart y Colón, Marqués de San Leonardo (died 1789, or 23.7.1791)*")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("4. 1792")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Antonio Valdés y Fernández-Bazán Guirós y Ocio (died 4.4.1816)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("5. 1794")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Francisco Javier Everardo Tilly y Paredes, Vizconde de Everardo & Marqués de Casa Tilly (died 11.12.1795)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("6. 1796")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Antonio González de Arce Paredes y Ulloa (died 23.2.1798)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("7. 1798")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Manuel Antonio Flórez Maldonado Martínez de Angulo y Bodquín (died 23.3.1798)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("8. 1798")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Juan Cayetano de Lángara, Marqués de la Victoria y del Real Transporte (died 18.1.1806)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("9. 1802")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("José Solano y Bote, Marqués del Socorro (died 24.4.1806)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("10. 1805")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Francisco de Borja y del Poyo, Marqués de Camachos (died 10.6.1808)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("11. 1805")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Francisco Gil de Taboada y de Lemos y Villamarín (died 1809)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("12. 9.11.1805")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Federico Gravina y Nápoli (died 9.3.1806)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("13. 3.11.1808")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Félix Ignacio de Tejada y Suárez de Lara (died 20.2.1817)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("14. 24.2.1817")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Ignacio María de Álava y Sáenz de Navarrete (died 26.5.1817)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("15. 6.6.1817")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Juan María Villavicencio y de la Sema (died 25.4.1830)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("16. 1.5.1830")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Juan José de Apodaca y Eliza, Conde de Venadito (died 11.1.1835)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("17. 25.1.1835")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Cayetano Valdés y Flores (died 6.2.1835)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0039-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Born in 1733, Francisco Gil de Taboada was a Navy officer and a politician. He rose to become a Brigadier in 1781, JdE in 1782, TG in 1789 and became Spain’s 11th Capitán General in 1805. In a political role, he was Governor of the Malvinas (Falkland Islands) in 1774–1777, 11th Viceroy of New Granada in 1789, 35th Viceroy of Peru from 1790 to 1796, and Ministro de Marina in April 1806, resigning from the last position in June 1808 due to the French occupation of Spain, dying in 1809. (MNM 5276)")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "page_40"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0040-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Born in 1767, Cayetano Valdés y Flores joined the Navy as a cadet in 1781. Rising rapidly in rank, he commanded the corvette (research vessel) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Atrevida")]), _vm._v(" which, with its sister-ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Descubierta")]), _vm._v(", was built for the round-the-world voyage of Brigadier Alejandro de Malaspina from 1789 to 1794. At Trafalgar, he commanded the 80-gun "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Neptuno")]), _vm._v(", and was seriously wounded, but on his recovery he was promoted to Jefe de Escuadra. He took part in the land campaigns of the Peninsula War as a TG against the French. He served as Minister for the Navy in 1820–1821, but his opposition to the absolutism of Fernando VII led to a death sentence, and he fled to England in 1823, not returning from exile until 1833 following the change in regime. Under Queen Isabel II he became Governor of Cádiz, Captain-General of the Navy, Minister of the Navy again, and President of the Spanish Cortes, all in short order, but died in early February 1835. (MNM 0676)")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("18. 16.1.1836")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Francisco Javier de Uriarte y Borja (died 29.11.1842)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("19. 12.2.1843")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("José Sartorio y Terol (died 30.12.1843)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("20. 2.6.1843")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Ramón Lorenzo Romay y Jiménez de Cisneros (died 23.5.1849)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("21. 15.9.1847")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("José Rodríguez de Arias y Alvárez de la Campana (died 26.1.1852)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("22. 17.2.1852")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Francisco Javier de Ulloa y Ramírez de Laredo (died 24.11.1855)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("23. 28.11.1855")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Dionisio Capaz Rendón y de León (died 27.12.1855)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("24. 13.2.1856")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Francisco Armero y Fernández de Peñaranda, Marqués de Nervión (died 1.7.1866)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab01"
  }, [_vm._v("25. 24.11.1858")]), _vm._v(" "), _c('td', {
    staticClass: "tab01"
  }, [_vm._v("Casimiro Vigodet y Garnica (died 2.1.1872)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "sourcet"
  }, [_vm._v("* Note that Pedro Fitz-James Stuart was the great-grandson of King James II of England and Arabella Churchill, and also (through his mother) the last descendent of the Colón family.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68f217ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12_Civilian.vue
// module id = 93
// module chunks = 0